export default {
  namespace: 'TokenModal',
  state: {
    root: {},
  },
  // 存放全局数据
  reducers: {
    // 储存登录用户信息
    setTokenModal(state, action) {
      return {
        ...state,
        root: action?.payload.root,
      };
    },
  },
  // 请求异步存放数据
  effects: {},

  subscriptions: {
    setup() {
      // eslint-disable-line
    },
  },
};
